export interface SistemAlertsDataDTO {
  license_plate: string;
  provider_name: string;
  actual_location: string;
  capacity: number | null;
  coverage: string;
  dlz: string;
  transport_id: number;
}

export class SistemAlertsListDTO {
  constructor(public data: SistemAlertsDataDTO[]) {}
}
